<template>
    <el-pagination
            v-bind="page.option"
            v-on="pagingListeners"
            @size-change="size=>(pagingListeners.sizeChange||sizeChange)(size)"
            @current-change="current=>(pagingListeners.currentChange||currentChange)(current)"
    >
    </el-pagination>
</template>

<script>
    import page from './page'
    export default {
        name: "kink-pagination",
        props: {
            pagingConfig: {//page组件参数
                type: Object,
                default() {
                    return {
                        emptyLayout: "total"//数据为空时
                    }
                }
            },
            pagingListeners: {//page组件监听事件
                type: Object,
                default() {
                    return {}
                }
            },
            loadAtOnce: {//是否立即加载数据
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                page: new page(this.pagingConfig, this.loadAtOnce)//分页核心控制对象
            }
        },
        methods: {
            search() {
                this.page.execute()
            },
            currentChange(currentPage) {
                this.page.option.currentPage = currentPage
                this.page.execute()
            },
            sizeChange(pageSize) {
                this.page.option.pageSize = pageSize
                this.page.execute()
            }
        }
    }
</script>

<style scoped>

</style>